// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.favourite-page {
    background: #ffffff;
    color: var(--mg-ink);
    padding: 72px 0 72px;
}

.favourite-hero {
    padding-top: 0;
}

.favourite-grid {
    padding-top: 32px;
}

.favourite-empty {
    align-items: center;
    border-bottom: 1px solid var(--mg-line);
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
    min-height: 360px;
    text-align: center;
}

.favourite-empty p { color: var(--mg-muted); margin: 0; }

.favourite-empty a {
    border: 1px solid #111;
    color: #111;
    font-size: 12px;
    letter-spacing: .1em;
    padding: 16px 28px;
    text-decoration: none;
    text-transform: uppercase;
}

@media (max-width: 540px) {
    .favourite-page {
        padding-top: 44px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/FavouriteContainer/FavouriteContainer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,qBAAqB,sBAAsB,EAAE,SAAS,EAAE;;AAExD;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".favourite-page {\n    background: #ffffff;\n    color: var(--mg-ink);\n    padding: 72px 0 72px;\n}\n\n.favourite-hero {\n    padding-top: 0;\n}\n\n.favourite-grid {\n    padding-top: 32px;\n}\n\n.favourite-empty {\n    align-items: center;\n    border-bottom: 1px solid var(--mg-line);\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    justify-content: center;\n    min-height: 360px;\n    text-align: center;\n}\n\n.favourite-empty p { color: var(--mg-muted); margin: 0; }\n\n.favourite-empty a {\n    border: 1px solid #111;\n    color: #111;\n    font-size: 12px;\n    letter-spacing: .1em;\n    padding: 16px 28px;\n    text-decoration: none;\n    text-transform: uppercase;\n}\n\n@media (max-width: 540px) {\n    .favourite-page {\n        padding-top: 44px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
